import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import {
	IntroSection,
	IntroSectionDescription,
	IntroSectionTitle,
} from "@/components/ui/IntroSection";
import {
	TabsList,
	TabsPanel,
	TabsRoot,
	TabsTrigger,
} from "@/components/ui/Tabs";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokProductSections } from "@/storyblok";
import styles from "./ProductSections.module.css";

export const ProductSectionsBlok = ({
	blok,
	preview,
}: BlokProps<BlokProductSections>) => {
	const firstValue = blok.sections?.at(0)?._uid;

	const viewMore = blok.viewMore?.at(0);
	const viewMoreLink = viewMore?.href
		? sbLink(viewMore?.href)?.href
		: undefined;
	return (
		<BlokWrap editable={blok} as="div" className={styles.root}>
			<IntroSection>
				<IntroSectionTitle>{blok.title}</IntroSectionTitle>
				{blok.description && (
					<IntroSectionDescription>{blok.description}</IntroSectionDescription>
				)}
			</IntroSection>
			<TabsRoot className={styles.tabs} defaultValue={firstValue}>
				<TabsList className={styles.inner}>
					{blok.sections?.map((section) => {
						return (
							<TabsTrigger
								render={<Button variant="filter">{section.title}</Button>}
								key={section._uid}
								value={section._uid}
							/>
						);
					})}
				</TabsList>

				<div className={styles.wrapperInner}>
					{blok.sections?.map((section) => {
						return (
							<TabsPanel
								className={styles.panel}
								value={section._uid}
								key={section._uid}
							>
								<StoryblokComponent
									insideSection
									blok={section}
									preview={preview}
								/>
							</TabsPanel>
						);
					})}
					{viewMore && viewMoreLink && (
						<div className={styles.linkWrapper}>
							<Link href={viewMoreLink} className={styles.link}>
								{viewMore.text}
							</Link>
						</div>
					)}
				</div>
			</TabsRoot>
		</BlokWrap>
	);
};
